import * as CL from '@design-system/component-library';
import { useLoaderData, useNavigate } from 'react-router';
import { dsClass } from '../../../../../common/constants/dsClasses.js';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams.js';
import {
  contactManagementInstructionsMsg,
  dataSourcesForContactDetailsMsg,
  omaElisaClassicSwitchMsg,
  t,
} from '../../../../../common/i18n/index.js';
import {
  CompanyInfoContainer,
  CompanyInfoSceneTab,
} from '../../../../../components/CompanyInfoScene/CompanyInfoScene.js';
import { ContactsList } from '../../../../../components/ContactsList/ContactsList.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { useAuth } from '../../../AuthProvider.js';
import { useConfig } from '../../../ConfigProvider';
import type { DefaultListSearchParams } from '../../../../../components/Table/index.js';
import type { ContactsResponse } from '../../../../../generated/api/contactsResponse.js';

import './CompanyInfoContactsPath.scss';

export const CompanyInfoContactsPath = () => {
  const config = useConfig();
  const navigate = useNavigate();
  const contacts = useLoaderData() as ContactsResponse;
  const { search } = useSearchParams<DefaultListSearchParams>();
  const { authenticatedUser } = useAuth();

  return (
    <CompanyInfoContainer tab={CompanyInfoSceneTab.CONTACTS}>
      <Grid>
        <div className="of-company-info-contacts-path">
          <div className="of-company-info-contacts-path__notification">
            <CL.NotificationBanner
              className={dsClass.TEXT_M}
              text={t.VYFI(
                'Adding and deleting OmaElisa administrators is currently only possible in OmaElisa Classic. With your Elisa ID, you can log into OmaElisa Classic, OmaElisa for Companies and some Elisa Ring services (e.g. web-admin and file archive).'
              )}
              icon={<CL.Icon icon="information" size="m" type="regular" color="blue-600" />}
              link={{
                text: t.DZMK(omaElisaClassicSwitchMsg),
                href: `${config.classicSiteUrl}/kayttajat`,
              }}
            />
          </div>

          <div className="of-company-info-contacts-path__headline-and-button">
            <div className={`${dsClass.COLOR_NEU} tral-500 of-company-info-contacts-path__instructions`}>
              <CL.Link
                className={dsClass.FONT_SIZE_MEDIUM}
                linkTarget="_blank"
                linkHref="https://yrityksille.elisa.fi/ohjeet/omaelisa-kayttajahallinta"
              >
                {t.D8IX(contactManagementInstructionsMsg)}{' '}
                <CL.Icon icon="external-link" size="s" type="regular" color="blue-600" />
              </CL.Link>
            </div>
            <div className="of-company-info-contacts-path__source-table">
              <div className={`${dsClass.TEXT_S} ${dsClass.COLOR_NEU} tral-500 of-company-info-contacts-path__source`}>
                {t.U3UL(dataSourcesForContactDetailsMsg)}
              </div>{' '}
              <div className="of-company-info-contacts-path__button">
                <CL.Button
                  className="of-company-info-contacts-path__button"
                  onClick={() => navigate(paths.COMPANY_INFO_CONTACTS_NEW)}
                >
                  {t.QQSJ('Add new user')}
                </CL.Button>
              </div>
            </div>
          </div>
          <ContactsList
            contacts={contacts?.searchResults || []}
            total={contacts?.total || 0}
            searchInput={search}
            authenticatedUser={authenticatedUser}
          />
        </div>
      </Grid>
    </CompanyInfoContainer>
  );
};
